'use client'

import { listCategories } from '@onclicks/sharedmedusa/medusaData/categories'
import { CategoryMedusaBlock as CategoryMedusaBlockTypes } from '@/payload-types'
import Link from 'next/link'
import React, { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'

const CategoryMedusaBlockClient: React.FC<CategoryMedusaBlockTypes> = (props) => {
  const { title } = props
  const [categories, setCategories] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const pathname = usePathname()

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await listCategories()
        setCategories(data || [])
      } catch (error) {
        console.error('Failed to get categories:', error)
      } finally {
        setLoading(false)
      }
    }
    getCategories()
  }, [])

  if (loading)
    return (
      <div>
        <svg className="mr-3 size-5 animate-spin" viewBox="0 0 24 24"></svg>
      </div>
    )
  if (categories.length === 0) return <p>Aucune catégorie trouvée.</p>

  return (
    <>
      <h1 className="text-[#FB7303] text-2xl font-bold mb-2">{title}</h1>
      {categories.map((category) => {
        const isActive = pathname.includes(category.handle)

        if (category.handle === 'coup-de-coeur') {
          return null
        }

        return (
          <Link href={`/boutique/${category.handle}`} key={category.id} className="block mb-2">
            <div
              className={`px-3 py-4 lg:pl-8 rounded font-bold hover:cursor-pointer text-left transition-colors ${
                isActive ? 'bg-[#FB7303] text-white' : 'bg-[#FFF1E5] text-black'
              }`}
            >
              <p>{category.name}</p>
            </div>
          </Link>
        )
      })}
    </>
  )
}

export default CategoryMedusaBlockClient
